import { defineComponent as s, computed as t } from "vue";
import c from "./component-library7.js";
import l from "./component-library283.js";
const f = /* @__PURE__ */ s({
  __name: "variant-selector",
  props: {
    isAccessible: { type: Boolean, default: !0 },
    displayName: { default: "Varianten" },
    hideName: { type: Boolean },
    type: { default: "text" },
    variants: { default: () => [] }
  },
  emits: ["select-variant"],
  setup(o) {
    const e = o, r = t(() => e.type === "COLOR"), a = t(
      () => e.variants.findIndex((i) => i.active)
    ), n = t(() => e.variants[a.value]?.name || "");
    return { __sfc: !0, props: e, isColorSelector: r, activeVariantIndex: a, activeVariantName: n, VariantSelectorColor: c, VariantSelectorBasic: l };
  }
});
export {
  f as default
};
